module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Gb-Ha-Ia-Ge.1ad62d93.png";